import { render, staticRenderFns } from "./LeaderDetail.vue?vue&type=template&id=429a60db&scoped=true&"
import script from "./LeaderDetail.vue?vue&type=script&lang=js&"
export * from "./LeaderDetail.vue?vue&type=script&lang=js&"
import style0 from "./LeaderDetail.vue?vue&type=style&index=0&id=429a60db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429a60db",
  null
  
)

export default component.exports